import React from 'react';

interface BabyGamesSectionProps {
  language: 'en' | 'mr';
}

const games = [
  { icon: '🍼', name: 'Bottle Guessing', nameMr: 'बोतल अनुमान' },
  { icon: '👶', name: 'Baby Photo Match', nameMr: 'बेबी फोटो जोड़' },
  { icon: '🎀', name: 'Nursery Rhyme Quiz', nameMr: 'लोरी क्विज' },
  { icon: '👪', name: 'Family Trivia', nameMr: 'पारिवारिक ज्ञान' },
];

export const BabyGamesSection: React.FC<BabyGamesSectionProps> = ({ language }) => {
  return (
    <section className="relative py-24 px-4">
      <div className="max-w-6xl mx-auto">
        <h2 className="text-center text-4xl font-black text-transparent bg-clip-text bg-gradient-to-r from-yellow-500 to-pink-500 mb-12">
          {language === 'mr' ? '🎮 मजेदार खेळ' : '🎮 Fun Games'}
        </h2>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
          {games.map((game, idx) => (
            <button
              key={idx}
              className="group bg-white rounded-2xl shadow-lg hover:shadow-xl p-6 border-4 border-yellow-300 hover:border-pink-400 transition-all transform hover:scale-110"
            >
              <div className="text-5xl mb-4">{game.icon}</div>
              <p className="font-bold text-gray-800 text-sm group-hover:text-pink-600 transition-colors">
                {language === 'mr' ? game.nameMr : game.name}
              </p>
            </button>
          ))}
        </div>

        <div className="text-center mt-12">
          <button className="px-8 py-4 bg-gradient-to-r from-yellow-400 to-pink-400 text-white font-bold rounded-full text-lg hover:shadow-lg transition-all hover:scale-110">
            {language === 'mr' ? '🎯 सभी खेळ देखें' : '🎯 View All Games'}
          </button>
        </div>
      </div>
    </section>
  );
};
